import ActivityCard from "components/ActivityPanel/ActivityCard";
import React from "react";
import ExcelTemplateActivityCardContent from "./ExcelTemplateActivityCardContent";

interface Props {
  activity: server.dto.ExcelTemplateActivity
}

export const ExcelTemplateActivityCard = (props: Props) => {
  const { activity } = props;

  return <ActivityCard
    activity={activity}
  >
    <ExcelTemplateActivityCardContent activity={activity} />
  </ActivityCard>
}